/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
  CompanyUserChallengeSettingsModelDto,
  InstitutionUisIdentitySettingDto,
  InstitutionUisIdentitySettingsModelDto,
  InstitutionUisIdentitySettingsResponseModelDto,
  UisSecurityLevelModelCollectionDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class CompanyUserChallengeSettingsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags CompanyUserChallengeSettings
   * @name CompanyUserChallengeSettingsGet
   * @summary End point to get company user challenge settings.
   * @request GET:/companyUserChallengeSettings
   */
  companyUserChallengeSettingsGet = (params: RequestParams = {}) =>
    this.http.request<CompanyUserChallengeSettingsModelDto, any>({
      path: `/companyUserChallengeSettings`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CompanyUserChallengeSettings
   * @name CompanyUserChallengeSettingsPut
   * @summary Update company user challenge settings.
   * @request PUT:/companyUserChallengeSettings
   */
  companyUserChallengeSettingsPut = (
    data: CompanyUserChallengeSettingsModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<CompanyUserChallengeSettingsModelDto, any>({
      path: `/companyUserChallengeSettings`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CompanyUserChallengeSettings
   * @name CompanyUserChallengeSettingsGetUisSecurityLevel
   * @summary Provides the endpoint to get UIS security levels.
   * @request GET:/companyUserChallengeSettings/uisSecurityLevel
   */
  companyUserChallengeSettingsGetUisSecurityLevel = (
    params: RequestParams = {},
  ) =>
    this.http.request<UisSecurityLevelModelCollectionDto, any>({
      path: `/companyUserChallengeSettings/uisSecurityLevel`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CompanyUserChallengeSettings
   * @name CompanyUserChallengeSettingsGetInstitutionUisIdentitySettings
   * @summary Provides the endpoint to get institution UIS Identity Settings.
   * @request GET:/companyUserChallengeSettings/institutionUisIdentitySettings
   */
  companyUserChallengeSettingsGetInstitutionUisIdentitySettings = (
    params: RequestParams = {},
  ) =>
    this.http.request<InstitutionUisIdentitySettingDto, any>({
      path: `/companyUserChallengeSettings/institutionUisIdentitySettings`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags CompanyUserChallengeSettings
   * @name CompanyUserChallengeSettingsSaveInstitutionUisIdentitySettings
   * @summary Provides the endpoint to get save UIS Identity Settings.
   * @request POST:/companyUserChallengeSettings/institutionUisIdentitySettings
   */
  companyUserChallengeSettingsSaveInstitutionUisIdentitySettings = (
    data: InstitutionUisIdentitySettingsModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<InstitutionUisIdentitySettingsResponseModelDto, any>({
      path: `/companyUserChallengeSettings/institutionUisIdentitySettings`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
